import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import classnames from "classnames";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { supabase } from "..";
import { toast } from "react-toastify";
import {
  DiarySliderSettings,
  PricingPlanCarouselSetting,
  RealReviewsSetting,
  RoundButton,
  RoundButtonDark,
  calculateMaxHeight,
  checkPathType,
  siteMapping,
  toastobj,
} from "../commonutilities";
import {
  getAppConf,
  getReviewList,
  getallsubscriptiondetail,
  registrationMail,
  seventhplans,
} from "../services/paymentService";
import { createUser } from "../services/supabaseService";

import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import {
  getJournalSettings,
  insertSettings,
} from "../services/journaldreamService";
import {
  saveFreemiumDream,
  saveGuestDataToPrev,
} from "../services/sightdreamService";

const options = {
  responsiveClass: true,
  nav: true,
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 2,
    },
    1000: {
      items: 2,
    },
  },
};

const options2 = {
  responsiveClass: true,
  nav: true,
  dots: false,
  responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    600: {
      items: 2,
    },
    700: {
      items: 3,
    },
    1000: {
      items: 3,
    },
  },
};

const items = [
  {
    title: "Fynley Wilkinson",
    subTitle: "Chief Creative Officer",
    caption:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit Etiam at ipsum at ligula vestibulum sodales Sed. Lorem ipsum dolor sit amet consectetur adipiscing elit Etiam at ipsum at ligula vestibulum sodales Sed. ",
    key: 1,
  },
  {
    title: "Wilkinson Fynley",
    subTitle: "Chief Creative Officer",
    caption:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit Etiam at ipsum at ligula vestibulum sodales Sed. Lorem ipsum dolor sit amet consectetur adipiscing elit Etiam at ipsum at ligula vestibulum sodales Sed. ",
    key: 2,
  },
];

function formatNumber(number) {
  let numberString = Number(number).toFixed(2);
  numberString = numberString.replace(/(\.[0-9])0$/, "$1");
  return parseFloat(numberString);
}

const Home = (args) => {
  const [open, setOpen] = useState("1");
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const history = useNavigate();
  const [plans, setplans] = useState({
    month: {},
    year: {},
    showplan: false,
  });

  const [email, setemail] = useState("");

  //new Seamless integration modal
  const [seamlessModal, setSeamlessModal] = useState(false);
  const [maxHeight, setMaxHeight] = useState(0);
  const [reviewList, setReviewList] = useState(null);
  const [isActiveFreeTrial, setIsActiveFreeTrial] = useState(false);
  const handlenewsletter = () => {
    if (email) {
      if (email.match(/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,8}$/g)) {
        supabase
          .from("newsletter")
          .select()
          .eq("email", email.trim())
          .then((res) => {
            if (res.error === null) {
              if (res.data.length === 0) {
                supabase
                  .from("newsletter")
                  .insert({
                    email,
                    created_at: new Date(),
                  })
                  .then((res) => {});
              }
            }
          });
        toast.success(`Email Subscription added successfully`, toastobj);
        setemail("");
      } else {
        toast.error(`Enter valid Email`, toastobj);
      }
    } else {
      toast.error(`Enter Email to continue..`, toastobj);
    }
  };

  useEffect(() => {
    async function checkauth() {
      const session = await supabase.auth.getSession();
      let authuser = localStorage.getItem("sevensight_user");
      if (
        !authuser &&
        session.data &&
        session.data.session &&
        session.data.session.user
      ) {
        let user = session.data.session.user;
        let obj2 = { ...user };
        obj2["token"] = session.data.session.access_token;
        if (user["identities"][0]["identity_data"]) {
          if (user["identities"][0]["identity_data"]["full_name"]) {
            obj2["user_name"] =
              user["identities"][0]["identity_data"]["full_name"];
          }
        }
        localStorage.setItem("sevensight_user", JSON.stringify(obj2));
        supabase
          .from("users")
          .select()
          .eq("email", session.data.session.user["email"])
          .then((res) => {
            if (res.data.length === 0) {
              let obj = {
                created_at: new Date(),
                email: user["email"].toLowerCase(),
              };
              if (user["identities"] && user["identities"].length > 0) {
                if (user["identities"][0]["identity_data"]) {
                  if (user["identities"][0]["identity_data"]["full_name"]) {
                    obj["name"] =
                      user["identities"][0]["identity_data"]["full_name"];
                  }
                }
              }
              registrationMail({ email: user["email"] });
              supabase
                .from("users")
                .insert(obj)
                .then((res) => {});
              let freeCreditValue = 0;
              getAppConf("free_credit_limit")
                .then((res) => {
                  if (res.data.status && res.data.value) {
                    freeCreditValue = res.data.value;
                  }
                })
                .catch((error) => {
                  // console.error("Error fetching free credit limit:", error);
                })
                .finally(() => {
                  const formdata = {
                    user_id: session.data.session.user["id"],
                    name: obj["name"],
                    email: session.data.session.user["email"],
                    created_at: session.data.session.user["created_at"],
                    updated_date: session.data.session.user["updated_at"],
                    guest_credits: freeCreditValue,
                    news_latter_unsubscribed: true,
                  };

                  createUser(formdata)
                    .then(() => {
                      // Optional: Do something after createUser() is done
                    })
                    .catch((error) => {
                      // console.error("Error creating user:", error);
                    });

                  let tempSaveGuestData = {
                    email: session.data.session.user["email"],
                  };
                  saveGuestDataToPrev(JSON.stringify(tempSaveGuestData)).then(
                    () => {}
                  );
                });
              /*let freemium = JSON.parse(
                sessionStorage.getItem("SeventhSightFreemium")
              );
              if (freemium && freemium?.dream) {
                sessionStorage.removeItem("SeventhSightFreemium");
                let freemiumData = {
                  analysis: freemium?.analysis,
                  chatbot_data_id: freemium?.chatbot_id,
                  email: session.data.session.user["email"],
                  journalDate: session.data.session.user["created_at"],
                  dream: freemium?.dream,
                  image: freemium?.image,
                };
                saveFreemiumDream(freemiumData);
              } */
            }
          });

        setDefaultJournalSettings(user.id);
      } else if (
        authuser &&
        session.data &&
        session.data.session &&
        session.data.session.user
      ) {
        let user = session.data.session.user;
        let obj2 = { ...user };
        obj2["token"] = session.data.session.access_token;
        if (user["identities"][0]["identity_data"]) {
          if (user["identities"][0]["identity_data"]["full_name"]) {
            obj2["user_name"] =
              user["identities"][0]["identity_data"]["full_name"];
          }
        }
        localStorage.setItem("sevensight_user", JSON.stringify(obj2));
        setDefaultJournalSettings(user.id);
      }
      if (session.data && session.data.session && session.data.session.user) {
        let redirectForOAuth = JSON.parse(
          sessionStorage.getItem("SeventhSightRedirect")
        );
        if (redirectForOAuth) {
          sessionStorage.removeItem("SeventhSightRedirect");
          let enredirectPath = redirectForOAuth?.redirectPath;
          const modifiedPath = enredirectPath.includes("/refresh_session/")
            ? enredirectPath.replace(
                "/refresh_session/",
                `/${session.data.session.refresh_token}/`
              )
            : enredirectPath;
          history(`/${modifiedPath}`);
        }
        getallsubscriptiondetail(
          session?.data?.session?.user?.id,
          session?.data?.session?.access_token
        )
          .then((res) => {
            if (res.data.status) {
              if (res.data.Subscriptions.length > 0) {
                setIsActiveFreeTrial(true);
              }
            }
          })
          .catch((err) => {});
      }
    }
    checkauth();
    getReviews();
    getplans();
  }, []);

  const getReviews = () => {
    const site = siteMapping[checkPathType()];
    let obj = JSON.parse(localStorage.getItem("sevensight_user"));
    getReviewList(site)
      .then((res) => {
        if (res?.status) {
          setReviewList(res?.data?.Reviews);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  const getplans = () => {
    seventhplans().then((response) => {
      if (response.data.status) {
        let year = {};
        let month = {};
        let arr = response.data.Plans.filter((ele) => {
          return ele["show_plan"];
        });
        arr.forEach((ele) => {
          if (ele.unique_key) {
            let spiltval = ele.unique_key.split("_");
            if (spiltval[0] === "month") {
              month[spiltval[1]] = ele;
            } else if (spiltval[0] === "year") {
              year[spiltval[1]] = ele;
            }
          }
        });
        if (Object.keys(month).length > 0) {
          setplans({ month, year, showplan: true });
        } else {
          setplans({ month, year, showplan: false });
        }
      }
    });
  };
  const setDefaultJournalSettings = (id) => {
    getJournalSettings(id).then((response) => {
      if (response.error === null) {
        if (response.data.length > 0) {
          let mode = response.data[0].night_mode;
          localStorage.setItem("seventh_journal_theme", JSON.stringify(mode));
        } else {
          let temp = {
            user_id: id,
            back_up_this_device: false,
            back_up_over_mobiledata: false,
            back_up_over_cloud: false,
            sync_all_device: false,
            night_mode: true,
            location: false,
            prompt_notification: false,
            reminder: false,
            gratitude: true,
            goals: false,
            password_enabled: false,
            auto_lock_enabled: false,
            auto_lock_timer: "",
            created_date: new Date().toISOString(),
            updated_date: new Date().toISOString(),
          };

          insertSettings(temp).then((response) => {
            if (response.error == null) {
              localStorage.setItem(
                "seventh_journal_theme",
                JSON.stringify(true)
              );
            } else {
              toast.error("Somthing went wrong!", toastobj);
            }
          });
        }
      }
    });
  };

  // Carousal

  // State for current active Tab
  const [currentActiveTab, setCurrentActiveTab] = useState("2");

  // Toggle active state for Tab
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const handleplan = () => {
    if (localStorage.getItem("sevensight_user")) {
      history("auth/account_subscription");
    } else {
      args.setloginmodalhome(true);
    }
  };

  const Signuphandleplan = () => {
    if (localStorage.getItem("sevensight_user")) {
      history("auth/account_subscription");
    } else {
      args.setsignupmodalhome(true);
    }
  };

  const toggleSeamlessModal = () => {
    setSeamlessModal(!seamlessModal);
  };

  //for responsive review boxes
  useEffect(() => {
    if (reviewList) {
      setMaxHeight(calculateMaxHeight(reviewList));
    }
  }, [reviewList]);

  return (
    <React.StrictMode>
      <div
        onClick={() => {
          args.toggleMenu();
        }}
      >
        <div className="new-home-bg">
          <div className="hero-main">
            <Container>
              <Row>
                <Col md="6" className="mobile-text-center">
                  <h2>
                    ANALYSE YOUR <span>DREAMS</span> <br />
                    IN SECONDS
                  </h2>
                  <p>
                    SeventhSight uses patented Machine Learning Artificial
                    Intelligence to analyse the meaning of your dream. Find
                    powerful insights into your daily life by understanding what
                    your subconscious is telling you!
                  </p>
                  <Link to="/analyze">
                    <Button type="button" color="primary">
                      Analyze My Dream Now!
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>

          <div className="hp-section1-new">
            <Container>
              <Row className="justify-content-center">
                <Col md="8">
                  <h2 className="text-center">
                    Why <span>understand</span> your dreams?
                  </h2>
                  <Row className="justify-content-center">
                    <Col md="7">
                      <p className="text-center main-text-color-new">
                        There are many benefits to understanding your
                        subconscious. It is a guide to many aspects of your life
                        always nudging you towards what's really important.
                      </p>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="4" className="commonlist">
                      <ul>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Better Relationships
                        </li>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Make Big Decisions
                        </li>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Find your Life Purpose
                        </li>
                      </ul>
                    </Col>

                    <Col md="4" className="commonlist">
                      <ul>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Repair Past Trauma
                        </li>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Improve your Career
                        </li>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Creative insights
                        </li>
                      </ul>
                    </Col>

                    <Col md="4" className="commonlist">
                      <ul>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Improve your intuition
                        </li>
                        <li>
                          <CheckCircleRoundedIcon className="hp-check-icon" />{" "}
                          Heal from Disease
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <div className="hp-section2-new">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <div className="hp-section2-new-inn">
                  <h4>
                    The privilege of a lifetime is to become who you really are
                  </h4>
                  <p>Carl Jung </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div>
          <div className="hp-section3-new">
            <Container>
              <Row>
                <Col>
                  <h2 className="text-center mb-5">
                    How it <span>Works</span>
                  </h2>
                </Col>
              </Row>
              <Row>
                <Col md="4" className="mb-5">
                  <div className="rounded bg-dark-blue p-3">
                    <div className="mb-4 mt-3">
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-seection2-icon4.png?t=2024-01-10T04%3A43%3A04.206Z"
                        alt=""
                      />
                    </div>
                    <h5>Write your dream</h5>
                    <p className="main-text-color-new">
                      Enter as much of your dream that you can remember into
                      your personalised journal. Simply wright down where you
                      were or what you saw.
                    </p>
                  </div>
                </Col>
                <Col md="4" className="mb-5">
                  <div className="rounded bg-dark-blue p-3">
                    <div className="mb-4 mt-3">
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-seection2-icon5.png?t=2024-01-10T04%3A43%3A46.990Z"
                        alt=""
                      />
                    </div>
                    <h5>Analyse your Dream</h5>
                    <p className="main-text-color-new">
                      We find meaning within the symbols of your dream. We
                      analyse patterns within those symbols and compare it with
                      your Arc personality.
                    </p>
                  </div>
                </Col>
                <Col md="4" className="mb-5">
                  <div className="rounded bg-dark-blue p-3">
                    <div className="mb-4 mt-3">
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-seection2-icon6.png?t=2024-01-10T04%3A44%3A09.384Z"
                        alt=""
                      />
                    </div>
                    <h5>Practical Results</h5>
                    <p className="main-text-color-new">
                      Receive detailed meanings of your dream and our powerful
                      insights that we found within that meaning to use and
                      guide you in your daily life.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button
                    className="btn-primary"
                    onClick={() => {
                      history("/create_subscription");
                    }}
                  >
                    Try it now for free
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
          <div className="hp-pricing-new-combine">
            <div
              className="hp-pricing-new "
              style={{ paddingTop: "0px! important" }}
            >
              <Container>
                <Row className="mb-3">
                  <Col md="6">
                    <h2>
                      our <span>Pricing</span> Plans
                    </h2>
                    <p>
                      Using powerful AI we created three platforms to understand
                      who you really are, to interpret your nightly visions, and
                      to improve your daily life based on who you are and what
                      your subconscious is telling you."
                    </p>
                  </Col>
                </Row>

                <Row className="paddingbottom50 home-tabs">
                  {plans["showplan"] && (
                    <Col>
                      <Nav tabs className="mb-5 pointer">
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: currentActiveTab === "1",
                            })}
                            onClick={() => {
                              toggle("1");
                            }}
                          >
                            Monthly
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({
                              active: currentActiveTab === "2",
                            })}
                            onClick={() => {
                              toggle("2");
                            }}
                          >
                            Yearly
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent activeTab={currentActiveTab}>
                        <TabPane tabId="1">
                          <div>
                            <Swiper loop {...PricingPlanCarouselSetting}>
                              <SwiperSlide key={1}>
                                <Col>
                                  <div className="hp-pricing-box">
                                    {/* <div className="hp-pricing-box-free">
                                <img src={hpPricingFreeLabel} alt="" />
                              </div> */}
                                    <div
                                      className="hp-bundle-ribbon"
                                      data-ribbon="BUNDLE"
                                      // style={'--d:0px;--c:orange;--f:25px;'}
                                    ></div>
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-integrated-package.png?t=2024-01-10T04%3A14%3A20.090Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-monthly${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <div className="flexColStart al-center">
                                        <h5>INTEGRATED PACKAGE</h5>
                                        {plans["month"]["all"]?.percentage_off >
                                          0 &&
                                        plans["month"]["all"].show_plan ? (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {formatNumber(
                                                plans["month"]["all"]
                                                  ?.special_price
                                              )}
                                            </h4>
                                            <h5 className="striked-discount-price">
                                              <s>
                                                ${plans["month"]["all"]?.price}
                                              </s>
                                            </h5>
                                          </div>
                                        ) : (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              ${plans["month"]["all"]?.price}
                                            </h4>
                                          </div>
                                        )}
                                      </div>

                                      <div
                                        className="flexColStart w-100 rg-05"
                                        style={{
                                          marginBottom: "16px",
                                        }}
                                      >
                                        <div className="flexRowStart  w-100 al-center">
                                          <img
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                            src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                            alt="icon"
                                          />
                                          <h6
                                            style={{
                                              margin: "0",
                                            }}
                                          >
                                            Al Powered Unlimited Dream Analysis
                                          </h6>
                                        </div>
                                        <div className="flexRowStart  w-100 al-center">
                                          <img
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                            src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                            alt="icon"
                                          />
                                          <h6
                                            style={{
                                              margin: "0",
                                            }}
                                          >
                                            AI Powered Daily Journal
                                          </h6>
                                        </div>
                                        <div className="flexRowStart  w-100 al-center">
                                          <img
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                            src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                            alt="icon"
                                          />
                                          <h6
                                            style={{
                                              margin: "0",
                                            }}
                                          >
                                            AI Powered Personality Test
                                          </h6>
                                        </div>
                                      </div>

                                      <p
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        Get even more insightful experience from
                                        the deeper discovery of your
                                        subconscious
                                      </p>
                                      <div
                                        className="flexRowStart w-100 al-center pointer"
                                        style={{
                                          justifyContent: "center",
                                        }}
                                        onClick={toggleSeamlessModal}
                                      >
                                        <p
                                          style={{
                                            color: "#A0A4D6",
                                            fontSize: "13px",
                                            lineHeight: "18px",
                                            fontWeight: "500",
                                            margin: "0",
                                          }}
                                        >
                                          Seamless Integration
                                        </p>
                                        <img
                                          style={{
                                            width: "12px",
                                            height: "12px",
                                          }}
                                          src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-help-circle.png"
                                          alt="icon"
                                        />
                                      </div>
                                      <Button
                                        onClick={Signuphandleplan}
                                        className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                      >
                                        Subscribe now
                                      </Button>
                                      {!isActiveFreeTrial && (
                                        <Button
                                          onClick={Signuphandleplan}
                                          className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                        >
                                          {args.noFreeTrialDays} days free trial
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={2}>
                                <Col>
                                  <div className="hp-pricing-box">
                                    {plans["month"]["sight"]?.percentage_off >
                                      0 &&
                                      plans["month"]["sight"].show_plan && (
                                        <div
                                          className="hp-discount-ribbon"
                                          data-ribbon={`-${plans["month"]["sight"]?.percentage_off}%`}
                                          // style={'--d:0px;--c:orange;--f:25px;'}
                                        ></div>
                                      )}

                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img1.png?t=2024-01-10T04%3A18%3A45.558Z"
                                      alt=""
                                    />
                                    {/* <div className="hp-pricing-box-free">
                                <img src={hpPricingFreeLabel} alt="" />
                              </div> */}
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-monthly${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <div className="flexColStart al-center">
                                        <h5>SEVENTHSIGHT</h5>
                                        {plans["month"]["sight"]
                                          ?.percentage_off > 0 &&
                                        plans["month"]["sight"].show_plan ? (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {formatNumber(
                                                plans["month"]["sight"]
                                                  ?.special_price
                                              )}
                                            </h4>
                                            <h5 className="striked-discount-price">
                                              <s>
                                                $
                                                {plans["month"]["sight"]?.price}
                                              </s>
                                            </h5>
                                          </div>
                                        ) : (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              ${plans["month"]["sight"]?.price}
                                            </h4>
                                          </div>
                                        )}
                                      </div>
                                      <h6>
                                        AI Powered Unlimited Dream Analysis.
                                      </h6>
                                      <p>
                                        Find insights from your dreams to make
                                        actionable changes in your life.
                                        Understand the symbols and discover the
                                        patterns your subconscious is telling
                                        you.
                                      </p>

                                      <Button
                                        onClick={Signuphandleplan}
                                        className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                      >
                                        Subscribe now
                                      </Button>
                                      {!isActiveFreeTrial && (
                                        <Button
                                          onClick={Signuphandleplan}
                                          className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                        >
                                          {args.noFreeTrialDays} days free trial
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={3}>
                                <Col>
                                  <div className="hp-pricing-box">
                                    {plans["month"]["journal"]?.percentage_off >
                                      0 &&
                                      plans["month"]["journal"].show_plan && (
                                        <div
                                          className="hp-discount-ribbon"
                                          data-ribbon={`-${plans["month"]["journal"]?.percentage_off}%`}
                                          // style={'--d:0px;--c:orange;--f:25px;'}
                                        ></div>
                                      )}

                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img4.png?t=2024-01-10T04%3A25%3A22.143Z"
                                      alt=""
                                    />
                                    {/* <div className="hp-pricing-box-free">
                                <img src={hpPricingFreeLabel} alt="" />
                              </div> */}
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-monthly${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <div className="flexColStart al-center">
                                        <h5>SEVENTHJOURN</h5>
                                        {plans["month"]["journal"]
                                          ?.percentage_off > 0 &&
                                        plans["month"]["journal"].show_plan ? (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {formatNumber(
                                                plans["month"]["journal"]
                                                  ?.special_price
                                              )}
                                            </h4>
                                            <h5 className="striked-discount-price">
                                              <s>
                                                $
                                                {
                                                  plans["month"]["journal"]
                                                    ?.price
                                                }
                                              </s>
                                            </h5>
                                          </div>
                                        ) : (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {plans["month"]["journal"]?.price}
                                            </h4>
                                          </div>
                                        )}
                                      </div>
                                      <h6>AI Powered Daily Journal.</h6>
                                      <p>
                                        Keep your thoughts noted, track your
                                        mood and get valuable insights with the
                                        help of an AI-powered Daily Journal
                                      </p>

                                      <Button
                                        onClick={Signuphandleplan}
                                        className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                      >
                                        Subscribe now
                                      </Button>
                                      {!isActiveFreeTrial && (
                                        <Button
                                          onClick={Signuphandleplan}
                                          className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                        >
                                          {args.noFreeTrialDays} days free trial
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={4}>
                                <Col>
                                  <div className="hp-pricing-box hp-pricing-box-disabled">
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img5.png?t=2024-01-10T04%3A27%3A39.120Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-monthly${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <h5>
                                        SeventhCare
                                        <br />${plans["month"]["care"]["price"]}
                                        {/* SeventhGuide $6<sup>99</sup> */}
                                      </h5>
                                      <h6>AI Powered Therapist</h6>
                                      <p>
                                        Keep your thoughts noted, track your
                                        mood and get valuable insights with the
                                        help of an AI-powered Daily Journal
                                      </p>
                                      <h3>
                                        Estimated <br />
                                        2024
                                      </h3>
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={5}>
                                <Col>
                                  <div className="hp-pricing-box hp-pricing-box-disabled">
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img3.png?t=2024-01-10T04%3A23%3A26.018Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-monthly${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <h5>
                                        SeventhGuide <br />$
                                        {plans["month"]["guide"]["price"]}
                                      </h5>
                                      <h6>Al Powered Guided Meditations</h6>
                                      <p>
                                        Use insights from SeventhSight and
                                        communicate directly with your
                                        subconscious to make radical positive
                                        health and habit changes at your core,
                                        and so much more!
                                      </p>
                                      <h3>
                                        Estimated <br />
                                        2024
                                      </h3>
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={6}>
                                <Col>
                                  <div className="hp-pricing-box hp-pricing-box-disabled">
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img6.png?t=2024-01-10T04%3A29%3A54.183Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-monthly${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <h5>
                                        Seventh...?
                                        {/* SeventhGuide $6<sup>99</sup> */}
                                      </h5>

                                      <h3>
                                        Estimated <br />
                                        2024
                                      </h3>
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SliderButtons />
                            </Swiper>
                          </div>
                        </TabPane>
                        <TabPane tabId="2">
                          <div>
                            <Swiper loop {...PricingPlanCarouselSetting}>
                              <SwiperSlide key={1}>
                                <Col>
                                  <div className="hp-pricing-box">
                                    {/* <div className="hp-pricing-box-free">
                                <img src={hpPricingFreeLabel} alt="" />
                              </div> */}
                                    <div
                                      className="hp-bundle-ribbon"
                                      data-ribbon="BUNDLE"
                                      // style={'--d:0px;--c:orange;--f:25px;'}
                                    ></div>
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-integrated-package.png?t=2024-01-10T04%3A14%3A20.090Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <div className="flexColStart al-center">
                                        <h5>INTEGRATED PACKAGE</h5>
                                        {plans["year"]["all"]?.percentage_off >
                                          0 &&
                                        plans["year"]["all"].show_plan ? (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {formatNumber(
                                                plans["year"]["all"]
                                                  ?.special_price
                                              )}
                                            </h4>
                                            <h5 className="striked-discount-price">
                                              <s>
                                                ${plans["year"]["all"]?.price}
                                              </s>
                                            </h5>
                                          </div>
                                        ) : (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              ${plans["year"]["all"]?.price}
                                            </h4>
                                          </div>
                                        )}
                                        {plans["month"]["all"]?.percentage_off >
                                          0 &&
                                        plans["month"]["all"].show_plan ? (
                                          <div className="flexColStart al-center">
                                            <p className="text-center">
                                              ( $
                                              {formatNumber(
                                                plans["month"]["all"]
                                                  ?.special_price
                                              )}
                                              /mo )
                                            </p>
                                          </div>
                                        ) : (
                                          <div className="flexColStart al-center">
                                            <p className="text-center">
                                              ( ${plans["month"]["all"]?.price}
                                              /mo )
                                            </p>
                                          </div>
                                        )}
                                      </div>

                                      <div
                                        className="flexColStart w-100 rg-05"
                                        style={{
                                          marginBottom: "16px",
                                        }}
                                      >
                                        <div className="flexRowStart  w-100 al-center">
                                          <img
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                            src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                            alt="icon"
                                          />
                                          <h6
                                            style={{
                                              margin: "0",
                                            }}
                                          >
                                            Al Powered Unlimited Dream Analysis
                                          </h6>
                                        </div>
                                        <div className="flexRowStart  w-100 al-center">
                                          <img
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                            src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                            alt="icon"
                                          />
                                          <h6
                                            style={{
                                              margin: "0",
                                            }}
                                          >
                                            AI Powered Daily Journal
                                          </h6>
                                        </div>
                                        <div className="flexRowStart  w-100 al-center">
                                          <img
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                            src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                            alt="icon"
                                          />
                                          <h6
                                            style={{
                                              margin: "0",
                                            }}
                                          >
                                            AI Powered Personality Test
                                          </h6>
                                        </div>
                                      </div>

                                      <p
                                        style={{
                                          textAlign: "left",
                                        }}
                                      >
                                        Get even more insightful experience from
                                        the deeper discovery of your
                                        subconscious
                                      </p>
                                      <div
                                        className="flexRowStart w-100 al-center pointer"
                                        style={{
                                          justifyContent: "center",
                                        }}
                                        onClick={toggleSeamlessModal}
                                      >
                                        <p
                                          style={{
                                            color: "#A0A4D6",
                                            fontSize: "13px",
                                            lineHeight: "18px",
                                            fontWeight: "500",
                                            margin: "0",
                                          }}
                                        >
                                          Seamless Integration
                                        </p>
                                        <img
                                          style={{
                                            width: "12px",
                                            height: "12px",
                                          }}
                                          src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-help-circle.png"
                                          alt="icon"
                                        />
                                      </div>
                                      <Button
                                        onClick={Signuphandleplan}
                                        className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                      >
                                        Subscribe now
                                      </Button>
                                      {!isActiveFreeTrial && (
                                        <Button
                                          onClick={Signuphandleplan}
                                          className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                        >
                                          {args.noFreeTrialDays} days free trial
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={2}>
                                <Col>
                                  <div className="hp-pricing-box">
                                    {plans["year"]["sight"]?.percentage_off >
                                      0 &&
                                      plans["year"]["sight"].show_plan && (
                                        <div
                                          className="hp-discount-ribbon"
                                          data-ribbon={`-${plans["year"]["sight"]?.percentage_off}%`}
                                          // style={'--d:0px;--c:orange;--f:25px;'}
                                        ></div>
                                      )}

                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img1.png?t=2024-01-10T04%3A18%3A45.558Z"
                                      alt=""
                                    />
                                    {/* <div className="hp-pricing-box-free">
                                <img src={hpPricingFreeLabel} alt="" />
                              </div> */}
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <div className="flexColStart al-center">
                                        <h5>SEVENTHSIGHT</h5>
                                        {plans["year"]["sight"]
                                          ?.percentage_off > 0 &&
                                        plans["year"]["sight"].show_plan ? (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {formatNumber(
                                                plans["year"]["sight"]
                                                  ?.special_price
                                              )}
                                            </h4>
                                            <h5 className="striked-discount-price">
                                              <s>
                                                ${plans["year"]["sight"]?.price}
                                              </s>
                                            </h5>
                                          </div>
                                        ) : (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              ${plans["year"]["sight"]?.price}
                                            </h4>
                                          </div>
                                        )}
                                        {plans["month"]["sight"]
                                          ?.percentage_off > 0 &&
                                        plans["month"]["sight"].show_plan ? (
                                          <div className="flexColStart al-center">
                                            <p className="text-center">
                                              ( $
                                              {formatNumber(
                                                plans["month"]["sight"]
                                                  ?.special_price
                                              )}
                                              /mo )
                                            </p>
                                          </div>
                                        ) : (
                                          <div className="flexColStart al-center">
                                            <p className="text-center">
                                              ( $
                                              {plans["month"]["sight"]?.price}
                                              /mo )
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <h6>
                                        AI Powered Unlimited Dream Analysis.
                                      </h6>
                                      <p>
                                        Find insights from your dreams to make
                                        actionable changes in your life.
                                        Understand the symbols and discover the
                                        patterns your subconscious is telling
                                        you.
                                      </p>

                                      <Button
                                        onClick={Signuphandleplan}
                                        className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                      >
                                        Subscribe now
                                      </Button>
                                      {!isActiveFreeTrial && (
                                        <Button
                                          onClick={Signuphandleplan}
                                          className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                        >
                                          {args.noFreeTrialDays} days free trial
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={3}>
                                <Col>
                                  <div className="hp-pricing-box">
                                    {plans["year"]["journal"]?.percentage_off >
                                      0 &&
                                      plans["year"]["journal"].show_plan && (
                                        <div
                                          className="hp-discount-ribbon"
                                          data-ribbon={`-${plans["year"]["journal"]?.percentage_off}%`}
                                          // style={'--d:0px;--c:orange;--f:25px;'}
                                        ></div>
                                      )}

                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img4.png?t=2024-01-10T04%3A25%3A22.143Z"
                                      alt=""
                                    />
                                    {/* <div className="hp-pricing-box-free">
                                <img src={hpPricingFreeLabel} alt="" />
                              </div> */}
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <div className="flexColStart al-center">
                                        <h5>SEVENTHJOURN</h5>
                                        {plans["year"]["journal"]
                                          ?.percentage_off > 0 &&
                                        plans["year"]["journal"].show_plan ? (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {formatNumber(
                                                plans["year"]["journal"]
                                                  ?.special_price
                                              )}
                                            </h4>
                                            <h5 className="striked-discount-price">
                                              <s>
                                                $
                                                {
                                                  plans["year"]["journal"]
                                                    ?.price
                                                }
                                              </s>
                                            </h5>
                                          </div>
                                        ) : (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              ${plans["year"]["journal"]?.price}
                                            </h4>
                                          </div>
                                        )}
                                        {plans["month"]["journal"]
                                          ?.percentage_off > 0 &&
                                        plans["month"]["journal"].show_plan ? (
                                          <div className="flexColStart al-center">
                                            <p className="text-center">
                                              ( $
                                              {formatNumber(
                                                plans["month"]["journal"]
                                                  ?.special_price
                                              )}
                                              /mo )
                                            </p>
                                          </div>
                                        ) : (
                                          <div className="flexColStart al-center">
                                            <p className="text-center">
                                              ( $
                                              {plans["month"]["journal"]?.price}
                                              /mo )
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <h6>AI Powered Daily Journal.</h6>
                                      <p>
                                        More than a journal, this AI-powered
                                        tool tracks your mood, analyzes
                                        patterns, and offers personalized
                                        insights and resource recommendations to
                                        help your personal growth and
                                        well-being.
                                      </p>

                                      <Button
                                        onClick={Signuphandleplan}
                                        className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                      >
                                        Subscribe now
                                      </Button>
                                      {!isActiveFreeTrial && (
                                        <Button
                                          onClick={Signuphandleplan}
                                          className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                        >
                                          {args.noFreeTrialDays} days free trial
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>

                              <SwiperSlide key={4}>
                                <Col>
                                  <div className="hp-pricing-box">
                                    {plans["year"]["arc"]?.percentage_off > 0 &&
                                      plans["year"]["arc"].show_plan && (
                                        <div
                                          className="hp-discount-ribbon"
                                          data-ribbon={`-${plans["year"]["arc"]?.percentage_off}%`}
                                          // style={'--d:0px;--c:orange;--f:25px;'}
                                        ></div>
                                      )}

                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img2.png?t=2024-01-10T04%3A21%3A07.842Z"
                                      alt=""
                                    />
                                    {/* <div className="hp-pricing-box-free">
                                <img src={hpPricingFreeLabel} alt="" />
                              </div> */}
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <div className="flexColStart al-center">
                                        <h5>SEVENTHARC</h5>
                                        {plans["year"]["arc"]?.percentage_off >
                                          0 &&
                                        plans["year"]["arc"].show_plan ? (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              $
                                              {formatNumber(
                                                plans["year"]["arc"]
                                                  ?.special_price
                                              )}
                                            </h4>
                                            <h5 className="striked-discount-price">
                                              <s>
                                                ${plans["year"]["arc"]?.price}
                                              </s>
                                            </h5>
                                          </div>
                                        ) : (
                                          <div className="flexRowStart cg-05">
                                            <h4>
                                              ${plans["year"]["arc"]?.price}
                                            </h4>
                                          </div>
                                        )}
                                      </div>
                                      <h6>
                                        Al Powered In-depth Personality Test
                                      </h6>
                                      <p>
                                        Find your archetype and your personal
                                        journey. We'll integrate your personal
                                        Archetype into your dedicated account
                                        for even better insights into your
                                        dreams and meditation visions.
                                      </p>

                                      <div
                                        className="flexRowStart w-100 al-center pointer"
                                        style={{
                                          justifyContent: "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: "#A0A4D6",
                                            fontSize: "13px",
                                            lineHeight: "18px",
                                            fontWeight: "500",
                                            margin: "0",
                                          }}
                                        >
                                          *Single Charge, Free Integration
                                        </p>
                                      </div>

                                      <Button
                                        onClick={Signuphandleplan}
                                        className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                      >
                                        Subscribe now
                                      </Button>
                                      {/* <Button
                                        onClick={Signuphandleplan}
                                        className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                      >
                                        {args.noFreeTrialDays} days free trial
                                      </Button> */}
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={5}>
                                <Col>
                                  <div className="hp-pricing-box hp-pricing-box-disabled">
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img5.png?t=2024-01-10T04%3A27%3A39.120Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <h5>
                                        SeventhCare
                                        <br />${plans["year"]["care"]["price"]}
                                        {/* SeventhGuide $6<sup>99</sup> */}
                                      </h5>
                                      <h6>AI Powered Therapist</h6>
                                      <p>
                                        Keep your thoughts noted, track your
                                        mood and get valuable insights with the
                                        help of an AI-powered Daily Journal
                                      </p>
                                      <h3>
                                        Estimated <br />
                                        2024
                                      </h3>
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={6}>
                                <Col>
                                  <div className="hp-pricing-box hp-pricing-box-disabled">
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img3.png?t=2024-01-10T04%3A23%3A26.018Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <h5>
                                        SeventhGuide <br />$
                                        {plans["year"]["guide"]["price"]}
                                      </h5>
                                      <h6>Al Powered Guided Meditations</h6>
                                      <p>
                                        Use insights from SeventhSight and
                                        communicate directly with your
                                        subconscious to make radical positive
                                        health and habit changes at your core,
                                        and so much more!
                                      </p>
                                      <h3>
                                        Estimated <br />
                                        2024
                                      </h3>
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SwiperSlide key={7}>
                                <Col>
                                  <div className="hp-pricing-box hp-pricing-box-disabled">
                                    <img
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img6.png?t=2024-01-10T04%3A29%3A54.183Z"
                                      alt=""
                                    />
                                    <div
                                      className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new${
                                        isActiveFreeTrial ? "-nofreetrial" : ""
                                      }`}
                                    >
                                      <h5>
                                        Seventh...?
                                        {/* SeventhGuide $6<sup>99</sup> */}
                                      </h5>

                                      <h3>
                                        Estimated <br />
                                        2024
                                      </h3>
                                    </div>
                                  </div>
                                </Col>
                              </SwiperSlide>
                              <SliderButtons />
                            </Swiper>
                          </div>
                        </TabPane>
                      </TabContent>
                    </Col>
                  )}
                </Row>
              </Container>
            </div>
          </div>
        </div>
        <div className="hp-section2-new">
          <Container>
            <Row className="justify-content-center">
              <Col md="8">
                <div className="hp-section2-new-inn">
                  <h4>
                    An uninterpreted dream is like an important phone call never
                    taken
                  </h4>
                  <p>The Talmud</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="">
          <div className="hp-section4-new">
            <Container>
              <Row className="align-items-center">
                <Col md="7">
                  <img
                    src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-seection4-img1.png"
                    alt=""
                  />
                </Col>
                <Col md="5">
                  <h3>
                    The App is <span>Coming Soon</span>
                  </h3>
                  <p>
                    Subscribe to our newsletter and be the first to know about
                    the launch and enjoy all the benefits of the SeventhSight
                    app
                  </p>
                  <Row className="align-items-center mt-4">
                    <Col md="7">
                      <input
                        type="text"
                        placeholder="Enter your email"
                        className="hp-subscribe-input"
                        value={email}
                        onChange={(e) => setemail(e.target.value)}
                      />
                    </Col>
                    <Col md="5">
                      <button
                        onClick={handlenewsletter}
                        className="btn btn-primary d-block"
                      >
                        Subscribe
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        <div className="hp-section6-new">
          <Container>
            {/* <div className="home-everybody-dreams">
							<Row className="mb-5">
								<h3>
									Everybody Dreams:
									<br /> <span></span>
									how to <span>remember your nightly visions</span>
								</h3>
								<Col md="6" className="hp-section6-content">
									<p>
										You dream every night - you just might not remember your
										dreams. On average everyone dreams about two hours a night
										but only 40% can remember even small parts of their dreams.
										Remembering your dreams is a skill that you can learn. Below
										are some techniques on how to remember your dreams and some
										basic understandings on how they are interpreted.
									</p>
									<div className="hp-section6-list-main">
										<div className="hp-section6-list-item">
											<img
												src={icon4}
												alt=""
												className="hp-section6-list-item-icon"
											/>
											<img
												src={icon4Hover}
												alt=""
												className="hp-section6-list-item-icon-hover"
											/>
											Understanding dreams basics
										</div>

										<div className="hp-section6-list-item">
											<img
												src={icon4}
												alt=""
												className="hp-section6-list-item-icon"
											/>
											<img
												src={icon4Hover}
												alt=""
												className="hp-section6-list-item-icon-hover"
											/>
											How best to journal your dream
										</div>

										<div className="hp-section6-list-item">
											<img
												src={icon4}
												alt=""
												className="hp-section6-list-item-icon"
											/>
											<img
												src={icon4Hover}
												alt=""
												className="hp-section6-list-item-icon-hover"
											/>
											How understanding dreams can help
										</div>

										<div className="hp-section6-list-item">
											<img
												src={icon4}
												alt=""
												className="hp-section6-list-item-icon"
											/>
											<img
												src={icon4Hover}
												alt=""
												className="hp-section6-list-item-icon-hover"
											/>
											Overcoming nightmares
										</div>
									</div>
								</Col>
								<Col md="6" className="text-right">
									<img src={img9} alt="" />
								</Col>
							</Row>
						</div> */}
            {/* <Row className="home-blogs">
							<Col>
								<Row>
									<Col>
										<h2 className="text-center">
											DREAM <span>BLOGS</span>
										</h2>
									</Col>
								</Row>
								<Row className="mb-3">
									<Col md={4} className="mx-auto">
										<p className="text-center">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit,
											sed do eiusmod tempor incididunt{' '}
										</p>
									</Col>
								</Row>
								<Row>
									<Col md={4}>
										<div className="home-blogs-box">
											<img src={hpBlogImg1} alt="" />
											<div className="home-blogs-cont">
												<div className="home-blogs-cont-title">Lorem ipsum</div>
												<p>
													Enter as much of your dream that you can remember into
													your personalised journal. Simply wright down where
													you were or what you saw.
												</p>
											</div>
										</div>
									</Col>

									<Col md={4}>
										<div className="home-blogs-box">
											<img src={hpBlogImg2} alt="" />
											<div className="home-blogs-cont home-blogs-cont2">
												<div className="home-blogs-cont-title">Lorem ipsum</div>
												<p>
													Enter as much of your dream that you can remember into
													your personalised journal. Simply wright down where
													you were or what you saw.
												</p>
											</div>
										</div>
									</Col>

									<Col md={4}>
										<div className="home-blogs-box">
											<img src={hpBlogImg3} alt="" />
											<div className="home-blogs-cont home-blogs-cont3">
												<div className="home-blogs-cont-title">Lorem ipsum</div>
												<p>
													Enter as much of your dream that you can remember into
													your personalised journal. Simply wright down where
													you were or what you saw.
												</p>
											</div>
										</div>
									</Col>
								</Row>
							</Col>
						</Row> */}

            <Row className="mb-3">
              <Col>
                <h2 className="text-center">
                  Options to <span>Analyze</span> your Dreams
                </h2>
              </Col>
            </Row>

            <Row className="hp-section6-cont hp-options-analyse-desktop">
              <Col md="4">
                <h4 className="text-center">Self Analysis</h4>
                <span className="main-text-color-new">
                  Self-analyzing dreams offers personal interpretation and
                  intimacy. Dreamers use resources to interpret symbols,
                  providing autonomy to discern feelings and experiences.
                  However, it's time-consuming and requires learning a broad
                  range of symbols. Without guidance, dreamers may head down
                  incorrect paths. The benefit is a deep personal journey,
                  demanding patience and dedication.
                </span>
              </Col>
              <Col md="4">
                <h4 className="text-center">Dream Specialist</h4>
                <span className="main-text-color-new">
                  Expert dream analysis offers a personalized, insightful
                  experience. Specialists understand symbolic language and the
                  uniqueness of each dreamer's subconscious expressions. Human
                  touch unveils profound interpretations reflecting personal
                  life and experiences, proving therapeutic and rewarding. While
                  expert guidance may be costly and time-consuming, the clarity
                  they provide can be valuable, especially for profound dreams.
                </span>
              </Col>
              <Col md="4">
                <h4
                  className="text-center"
                  style={{ border: "1px solid #8850FF", color: "#8850FF" }}
                >
                  Seventh Sight
                </h4>
                <span className="main-text-color-new">
                  SeventhSIGHT, an innovative dream interpretation tool, employs
                  advanced pattern recognition technology for instant analysis.
                  It combines global symbology with personal journal entries,
                  delivering insightful interpretations within seconds. While
                  lacking human intuition, it provides round-the-clock access at
                  a minimal cost, making it ideal for those seeking instant
                  insights and an objective viewpoint. SeventhSIGHT's efficiency
                  makes it a compelling choice for modern dream exploration.
                </span>
              </Col>
            </Row>

            <div className="hp-options-analyse-mobile">
              <Accordion open={open} toggle={toggleAccordion}>
                <AccordionItem>
                  <AccordionHeader targetId="1">Self Analysis</AccordionHeader>
                  <AccordionBody accordionId="1">
                    Self-analyzing dreams offers personal interpretation and
                    intimacy. Dreamers use resources to interpret symbols,
                    providing autonomy to discern feelings and experiences.
                    However, it's time-consuming and requires learning a broad
                    range of symbols. Without guidance, dreamers may head down
                    incorrect paths. The benefit is a deep personal journey,
                    demanding patience and dedication.
                  </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                  <AccordionHeader targetId="2">
                    Dream Specialist
                  </AccordionHeader>
                  <AccordionBody accordionId="2">
                    Expert dream analysis offers a personalized, insightful
                    experience. Specialists understand symbolic language and the
                    uniqueness of each dreamer's subconscious expressions. Human
                    touch unveils profound interpretations reflecting personal
                    life and experiences, proving therapeutic and rewarding.
                    While expert guidance may be costly and time-consuming, the
                    clarity they provide can be valuable, especially for
                    profound dreams.
                  </AccordionBody>
                </AccordionItem>
                <AccordionItem>
                  <AccordionHeader targetId="3">Seventh Sight</AccordionHeader>
                  <AccordionBody accordionId="3">
                    SeventhSIGHT, an innovative dream interpretation tool,
                    employs advanced pattern recognition technology for instant
                    analysis. It combines global symbology with personal journal
                    entries, delivering insightful interpretations within
                    seconds. While lacking human intuition, it provides
                    round-the-clock access at a minimal cost, making it ideal
                    for those seeking instant insights and an objective
                    viewpoint. SeventhSIGHT's efficiency makes it a compelling
                    choice for modern dream exploration.
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
            </div>
          </Container>
        </div>

        {/* <div className="hp-tremendous">
					<Container>
						<Row className="align-items-center">
							<Col className="hp-tremendous-left">
								<div className="hp-tremendous-item hp-tremendous-item-right">
									<Row className="hp-tremendous-bg1">
										<Col>
											<h5>Free</h5>
										</Col>
										<Col className="text-right">
											<h6>AUG</h6>
										</Col>
									</Row>
									<Row className="hp-tremendous-bg2">
										<Col>SeventhSIGHT: Official Launch</Col>
									</Row>
								</div>

								<div className="hp-tremendous-item hp-tremendous-item-left">
									<Row className="hp-tremendous-bg1">
										<Col>
											<h5>
												70% <span>off</span>
											</h5>
										</Col>
										<Col className="text-right">
											<h6>SEP</h6>
										</Col>
									</Row>
									<Row className="hp-tremendous-bg2">
										<Col>SeventhSIGHT: Official Launch</Col>
									</Row>
								</div>

								<div className="hp-tremendous-item hp-tremendous-item-right">
									<Row className="hp-tremendous-bg1">
										<Col>
											<h5>
												50% <span>off</span>
											</h5>
										</Col>
										<Col className="text-right">
											<h6>OCT</h6>
										</Col>
									</Row>
									<Row className="hp-tremendous-bg2">
										<Col>
											SIGHT <span>.</span> ARC <span>.</span> JOURNAL
										</Col>
									</Row>
								</div>

								<div className="hp-tremendous-item hp-tremendous-item-left">
									<Row className="hp-tremendous-bg1">
										<Col>
											<h5>
												30% <span>off</span>
											</h5>
										</Col>
										<Col className="text-right">
											<h6>NOV</h6>
										</Col>
									</Row>
									<Row className="hp-tremendous-bg2">
										<Col>
											SIGHT <span>.</span> ARC <span>.</span> JOURNAL
										</Col>
									</Row>
								</div>

								<div className="hp-tremendous-item hp-tremendous-item-right">
									<Row className="hp-tremendous-bg1">
										<Col>
											<h5>
												BUNDLE <span>20% off</span>
											</h5>
										</Col>
										<Col className="text-right">
											<h6>DEC</h6>
										</Col>
									</Row>
									<Row className="hp-tremendous-bg2">
										<Col>
											SIGHT <span>.</span> GUIDE <span>.</span> ARC{' '}
											<span>.</span> JOURNAL <span>.</span> CARE
										</Col>
									</Row>
								</div>
							</Col>
							<Col>
								<h2>
									Tremendous <span>discounts</span>
								</h2>
								<p className="main-text-color-new">
									We are thrilled to introduce these five new groundbreaking
									services - all to be interconnected!{' '}
								</p>

								<p className="main-text-color-new">
									In recognition of this momentous occasion and in gratitude for
									your support through this journey, we're offering an exclusive
									special: enjoy a significant discount on either a one-month or
									a one-year subscription.{' '}
								</p>

								<p className="main-text-color-new">
									Although the discount will decrease after this month, you have
									the chance to secure a one-year subscription at this fantastic
									rate today. Take this opportunity to explore our ever-evolving
									features at an unbeatable price.{' '}
								</p>

								<p className="main-text-color-new">
									Please help us with feedback - We're listening to you!
								</p>
							</Col>
						</Row>
					</Container>
				</div> */}

        <div className="hp_services_together">
          <Container>
            <Row>
              <Col>
                <h2 className="text-center">
                  See How all 5 services Work Together
                </h2>
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <img
                  src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp_services_icons.png?t=2024-01-10T04%3A54%3A02.823Z"
                  alt=""
                />
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <Button onClick={() => history("/inter-connections")}>
                  Learn more
                </Button>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Pricing New  */}
        <div className="hp-pricing-new-combine">
          {/* <div className="hp-pricing-new pricing-plans-section-home">
						<Container>
							<Row className="mb-3">
								<Col md="6">
									<h2>
										Our <span>Pricing</span> Plans
									</h2>
									<p>
										Using powerful AI we created three platforms to understand
										who you really are, to interpret your nightly visions, and
										to improve your daily life based on who you are and what
										your subconscious is telling you."
									</p>
								</Col>
							</Row>

							<Row className="paddingbottom50 home-tabs">
								{plans['showplan'] && (
									<Col>
										<Nav tabs className="mb-5 pointer">
											<NavItem>
												<NavLink
													className={classnames({
														active: currentActiveTab === '1',
													})}
													onClick={() => {
														toggle('1');
													}}
												>
													Monthly
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													className={classnames({
														active: currentActiveTab === '2',
													})}
													onClick={() => {
														toggle('2');
													}}
												>
													Yearly
												</NavLink>
											</NavItem>
										</Nav>
										<TabContent activeTab={currentActiveTab}>
											<TabPane tabId="1">
												<div>
													<Swiper loop {...PricingPlanCarouselSetting}>
														<SwiperSlide key={1}>
															<Col>
																<div className="hp-pricing-box">
																	
																	<div
																		className="hp-bundle-ribbon"
																		data-ribbon="BUNDLE"
																		
																	></div>
																	<img src={hpIntegratedImg} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3">
																		<div className="flexColStart al-center">
																			<h5>INTEGRATED PACKAGE</h5>
																			{plans['month']['all']?.percentage_off >
																				0 && plans['month']['all'].show_plan ? (
																				<div className="flexRowStart cg-05">
																					<h4>
																						$
																						{
																							plans['month']['all']
																								?.special_price
																						}
																					</h4>
																					<h5 className="striked-discount-price">
																						<s>
																							${plans['month']['all']?.price}
																						</s>
																					</h5>
																				</div>
																			) : (
																				<div className="flexRowStart cg-05">
																					<h4>
																						${plans['month']['all']?.price}
																					</h4>
																				</div>
																			)}
																		</div>

																		<div
																			className="flexColStart w-100 rg-05"
																			style={{
																				marginBottom: '16px',
																			}}
																		>
																			<div className="flexRowStart  w-100 al-center">
																				<img
																					style={{
																						width: '16px',
																						height: '16px',
																					}}
																					src={iconGreenTick}
																					alt="icon"
																				/>
																				<h6
																					style={{
																						margin: '0',
																					}}
																				>
																					Al Powered Unlimited Dream Analysis
																				</h6>
																			</div>
																			<div className="flexRowStart  w-100 al-center">
																				<img
																					style={{
																						width: '16px',
																						height: '16px',
																					}}
																					src={iconGreenTick}
																					alt="icon"
																				/>
																				<h6
																					style={{
																						margin: '0',
																					}}
																				>
																					AI Powered Daily Journal
																				</h6>
																			</div>
																		</div>

																		<p
																			style={{
																				textAlign: 'left',
																			}}
																		>
																			Get even more insightful experience from
																			the deeper discovery of your subconscious
																		</p>
																		<div
																			className="flexRowStart w-100 al-center pointer"
																			style={{
																				justifyContent: 'center',
																			}}
																			onClick={toggleSeamlessModal}
																		>
																			<p
																				style={{
																					color: '#A0A4D6',
																					fontSize: '13px',
																					lineHeight: '18px',
																					fontWeight: '500',
																					margin: '0',
																				}}
																			>
																				Seamless Integration
																			</p>
																			<img
																				style={{
																					width: '12px',
																					height: '12px',
																				}}
																				src={helpIconCircle}
																				alt="icon"
																			/>
																		</div>
																		<Button
																			onClick={handleplan}
																			className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
																		>
																			Subscribe now
																		</Button>
																		<Button
																			onClick={handleplan}
																			className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
																		>
																			7 days free trial
																		</Button>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={2}>
															<Col>
																<div className="hp-pricing-box">
																	{plans['month']['sight']?.percentage_off >
																		0 &&
																		plans['month']['sight'].show_plan && (
																			<div
																				className="hp-discount-ribbon"
																				data-ribbon={`-${plans['month']['sight']?.percentage_off}%`}
																				
																			></div>
																		)}

																	<img src={hpPrinngImg1} alt="" />
																	
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3">
																		<div className="flexColStart al-center">
																			<h5>SEVENTHSIGHT</h5>
																			{plans['month']['sight']?.percentage_off >
																				0 &&
																			plans['month']['sight'].show_plan ? (
																				<div className="flexRowStart cg-05">
																					<h4>
																						$
																						{
																							plans['month']['sight']
																								?.special_price
																						}
																					</h4>
																					<h5 className="striked-discount-price">
																						<s>
																							${plans['month']['sight']?.price}
																						</s>
																					</h5>
																				</div>
																			) : (
																				<div className="flexRowStart cg-05">
																					<h4>
																						${plans['month']['sight']?.price}
																					</h4>
																				</div>
																			)}
																		</div>
																		<h6>
																			AI Powered Unlimited Dream Analysis.
																		</h6>
																		<p>
																			Find insights from your dreams to make
																			actionable changes in your life.
																			Understand the symbols and discover the
																			patterns your subconscious is telling you.
																		</p>

																		<Button
																			onClick={handleplan}
																			className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
																		>
																			Subscribe now
																		</Button>
																		<Button
																			onClick={handleplan}
																			className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
																		>
																			7 days free trial
																		</Button>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={3}>
															<Col>
																<div className="hp-pricing-box">
																	{plans['month']['journal']?.percentage_off >
																		0 &&
																		plans['month']['journal'].show_plan && (
																			<div
																				className="hp-discount-ribbon"
																				data-ribbon={`-${plans['month']['journal']?.percentage_off}%`}
																				
																			></div>
																		)}

																	<img src={hpPrinngImg4} alt="" />
																	
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3">
																		<div className="flexColStart al-center">
																			<h5>SEVENTHJOURN</h5>
																			{plans['month']['journal']
																				?.percentage_off > 0 &&
																			plans['month']['journal'].show_plan ? (
																				<div className="flexRowStart cg-05">
																					<h4>
																						$
																						{
																							plans['month']['journal']
																								?.special_price
																						}
																					</h4>
																					<h5 className="striked-discount-price">
																						<s>
																							$
																							{plans['month']['journal']?.price}
																						</s>
																					</h5>
																				</div>
																			) : (
																				<div className="flexRowStart cg-05">
																					<h4>
																						${plans['month']['journal']?.price}
																					</h4>
																				</div>
																			)}
																		</div>
																		<h6>AI Powered Daily Journal.</h6>
																		<p>
																			Keep your thoughts noted, track your mood
																			and get valuable insights with the help of
																			an AI-powered Daily Journal
																		</p>

																		<Button
																			onClick={handleplan}
																			className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
																		>
																			Subscribe now
																		</Button>
																		<Button
																			onClick={handleplan}
																			className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
																		>
																			7 days free trial
																		</Button>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={4}>
															<Col>
																<div className="hp-pricing-box hp-pricing-box-disabled">
																	<img src={hpPrinngImg5} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new">
																		<h5>
																			SeventhCare
																			<br />${plans['month']['care']['price']}
																			
																		</h5>
																		<h6>AI Powered Therapist</h6>
																		<p>
																			Keep your thoughts noted, track your mood
																			and get valuable insights with the help of
																			an AI-powered Daily Journal
																		</p>
																		<h3>
																			Estimated <br />
																			JANUARY 2024
																		</h3>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={5}>
															<Col>
																<div className="hp-pricing-box hp-pricing-box-disabled">
																	<img src={hpPrinngImg3} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new">
																		<h5>
																			SeventhGuide <br />$
																			{plans['month']['guide']['price']}
																		</h5>
																		<h6>Al Powered Guided Meditations</h6>
																		<p>
																			Use insights from SeventhSight and
																			communicate directly with your
																			subconscious to make radical positive
																			health and habit changes at your core, and
																			so much more!
																		</p>
																		<h3>
																			Estimated <br />
																			MARCH 2024
																		</h3>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={6}>
															<Col>
																<div className="hp-pricing-box hp-pricing-box-disabled">
																	<img src={hpPrinngImg6} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new">
																		<h5>
																			Seventh...?
																			
																		</h5>

																		<h3>
																			Estimated <br />
																			2024
																		</h3>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SliderButtons />
													</Swiper>
												</div>
											</TabPane>
											<TabPane tabId="2">
												<div>
													<Swiper loop {...PricingPlanCarouselSetting}>
														<SwiperSlide key={1}>
															<Col>
																<div className="hp-pricing-box">
																	
																	<div
																		className="hp-bundle-ribbon"
																		data-ribbon="BUNDLE"
																		// style={'--d:0px;--c:orange;--f:25px;'}
																	></div>
																	<img src={hpIntegratedImg} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3">
																		<div className="flexColStart al-center">
																			<h5>INTEGRATED PACKAGE</h5>
																			{plans['year']['all']?.percentage_off >
																				0 && plans['year']['all'].show_plan ? (
																				<div className="flexRowStart cg-05">
																					<h4>
																						$
																						{
																							plans['year']['all']
																								?.special_price
																						}
																					</h4>
																					<h5 className="striked-discount-price">
																						<s>
																							${plans['year']['all']?.price}
																						</s>
																					</h5>
																				</div>
																			) : (
																				<div className="flexRowStart cg-05">
																					<h4>
																						${plans['year']['all']?.price}
																					</h4>
																				</div>
																			)}
																		</div>

																		<div
																			className="flexColStart w-100 rg-05"
																			style={{
																				marginBottom: '16px',
																			}}
																		>
																			<div className="flexRowStart  w-100 al-center">
																				<img
																					style={{
																						width: '16px',
																						height: '16px',
																					}}
																					src={iconGreenTick}
																					alt="icon"
																				/>
																				<h6
																					style={{
																						margin: '0',
																					}}
																				>
																					Al Powered Unlimited Dream Analysis
																				</h6>
																			</div>
																			<div className="flexRowStart  w-100 al-center">
																				<img
																					style={{
																						width: '16px',
																						height: '16px',
																					}}
																					src={iconGreenTick}
																					alt="icon"
																				/>
																				<h6
																					style={{
																						margin: '0',
																					}}
																				>
																					AI Powered Daily Journal
																				</h6>
																			</div>
																		</div>

																		<p
																			style={{
																				textAlign: 'left',
																			}}
																		>
																			Get even more insightful experience from
																			the deeper discovery of your subconscious
																		</p>
																		<div
																			className="flexRowStart w-100 al-center pointer"
																			style={{
																				justifyContent: 'center',
																			}}
																			onClick={toggleSeamlessModal}
																		>
																			<p
																				style={{
																					color: '#A0A4D6',
																					fontSize: '13px',
																					lineHeight: '18px',
																					fontWeight: '500',
																					margin: '0',
																				}}
																			>
																				Seamless Integration
																			</p>
																			<img
																				style={{
																					width: '12px',
																					height: '12px',
																				}}
																				src={helpIconCircle}
																				alt="icon"
																			/>
																		</div>
																		<Button
																			onClick={handleplan}
																			className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
																		>
																			Subscribe now
																		</Button>
																		<Button
																			onClick={handleplan}
																			className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
																		>
																			7 days free trial
																		</Button>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={2}>
															<Col>
																<div className="hp-pricing-box">
																	{plans['year']['sight']?.percentage_off > 0 &&
																		plans['year']['sight'].show_plan && (
																			<div
																				className="hp-discount-ribbon"
																				data-ribbon={`-${plans['year']['sight']?.percentage_off}%`}
																				// style={'--d:0px;--c:orange;--f:25px;'}
																			></div>
																		)}

																	<img src={hpPrinngImg1} alt="" />
																	
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3">
																		<div className="flexColStart al-center">
																			<h5>SEVENTHSIGHT</h5>
																			{plans['year']['sight']?.percentage_off >
																				0 &&
																			plans['year']['sight'].show_plan ? (
																				<div className="flexRowStart cg-05">
																					<h4>
																						$
																						{
																							plans['year']['sight']
																								?.special_price
																						}
																					</h4>
																					<h5 className="striked-discount-price">
																						<s>
																							${plans['year']['sight']?.price}
																						</s>
																					</h5>
																				</div>
																			) : (
																				<div className="flexRowStart cg-05">
																					<h4>
																						${plans['year']['sight']?.price}
																					</h4>
																				</div>
																			)}
																		</div>
																		<h6>
																			AI Powered Unlimited Dream Analysis.
																		</h6>
																		<p>
																			Find insights from your dreams to make
																			actionable changes in your life.
																			Understand the symbols and discover the
																			patterns your subconscious is telling you.
																		</p>

																		<Button
																			onClick={handleplan}
																			className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
																		>
																			Subscribe now
																		</Button>
																		<Button
																			onClick={handleplan}
																			className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
																		>
																			7 days free trial
																		</Button>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={3}>
															<Col>
																<div className="hp-pricing-box">
																	{plans['year']['journal']?.percentage_off >
																		0 &&
																		plans['year']['journal'].show_plan && (
																			<div
																				className="hp-discount-ribbon"
																				data-ribbon={`-${plans['year']['journal']?.percentage_off}%`}
																				// style={'--d:0px;--c:orange;--f:25px;'}
																			></div>
																		)}

																	<img src={hpPrinngImg4} alt="" />
																	
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3">
																		<div className="flexColStart al-center">
																			<h5>SEVENTHJOURN</h5>
																			{plans['year']['journal']
																				?.percentage_off > 0 &&
																			plans['year']['journal'].show_plan ? (
																				<div className="flexRowStart cg-05">
																					<h4>
																						$
																						{
																							plans['year']['journal']
																								?.special_price
																						}
																					</h4>
																					<h5 className="striked-discount-price">
																						<s>
																							${plans['year']['journal']?.price}
																						</s>
																					</h5>
																				</div>
																			) : (
																				<div className="flexRowStart cg-05">
																					<h4>
																						${plans['year']['journal']?.price}
																					</h4>
																				</div>
																			)}
																		</div>
																		<h6>AI Powered Daily Journal.</h6>
																		<p>
																			More than a journal, this AI-powered tool
																			tracks your mood, analyzes patterns, and
																			offers personalized insights and resource
																			recommendations to help your personal
																			growth and well-being.
																		</p>

																		<Button
																			onClick={handleplan}
																			className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
																		>
																			Subscribe now
																		</Button>
																		<Button
																			onClick={handleplan}
																			className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
																		>
																			7 days free trial
																		</Button>
																	</div>
																</div>
															</Col>
														</SwiperSlide>

														<SwiperSlide key={4}>
															<Col>
																<div className="hp-pricing-box">
																	{plans['year']['arc']?.percentage_off > 0 &&
																		plans['year']['arc'].show_plan && (
																			<div
																				className="hp-discount-ribbon"
																				data-ribbon={`-${plans['year']['arc']?.percentage_off}%`}
																				// style={'--d:0px;--c:orange;--f:25px;'}
																			></div>
																		)}

																	<img src={hpPrinngImg2} alt="" />
																	
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3">
																		<div className="flexColStart al-center">
																			<h5>SEVENTHARC</h5>
																			{plans['year']['arc']?.percentage_off >
																				0 && plans['year']['arc'].show_plan ? (
																				<div className="flexRowStart cg-05">
																					<h4>
																						$
																						{
																							plans['year']['arc']
																								?.special_price
																						}
																					</h4>
																					<h5 className="striked-discount-price">
																						<s>
																							${plans['year']['arc']?.price}
																						</s>
																					</h5>
																				</div>
																			) : (
																				<div className="flexRowStart cg-05">
																					<h4>
																						${plans['year']['arc']?.price}
																					</h4>
																				</div>
																			)}
																		</div>
																		<h6>
																			Al Powered In-depth Personality Test
																		</h6>
																		<p>
																			Find your archetype and your personal
																			journey. We'll integrate your personal
																			Archetype into your dedicated account for
																			even better insights into your dreams and
																			meditation visions.
																		</p>

																		<div
																			className="flexRowStart w-100 al-center pointer"
																			style={{
																				justifyContent: 'center',
																			}}
																		>
																			<p
																				style={{
																					color: '#A0A4D6',
																					fontSize: '13px',
																					lineHeight: '18px',
																					fontWeight: '500',
																					margin: '0',
																				}}
																			>
																				*Single Charge, Free Integration
																			</p>
																		</div>

																		<Button
																			onClick={handleplan}
																			className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
																		>
																			Subscribe now
																		</Button>
																		<Button
																			onClick={handleplan}
																			className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
																		>
																			7 days free trial
																		</Button>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={5}>
															<Col>
																<div className="hp-pricing-box hp-pricing-box-disabled">
																	<img src={hpPrinngImg5} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new">
																		<h5>
																			SeventhCare
																			<br />${plans['year']['care']['price']}
																			
																		</h5>
																		<h6>AI Powered Therapist</h6>
																		<p>
																			Keep your thoughts noted, track your mood
																			and get valuable insights with the help of
																			an AI-powered Daily Journal
																		</p>
																		<h3>
																			Estimated <br />
																			JANUARY 2024
																		</h3>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={6}>
															<Col>
																<div className="hp-pricing-box hp-pricing-box-disabled">
																	<img src={hpPrinngImg3} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new">
																		<h5>
																			SeventhGuide <br />$
																			{plans['year']['guide']['price']}
																		</h5>
																		<h6>Al Powered Guided Meditations</h6>
																		<p>
																			Use insights from SeventhSight and
																			communicate directly with your
																			subconscious to make radical positive
																			health and habit changes at your core, and
																			so much more!
																		</p>
																		<h3>
																			Estimated <br />
																			MARCH 2024
																		</h3>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SwiperSlide key={7}>
															<Col>
																<div className="hp-pricing-box hp-pricing-box-disabled">
																	<img src={hpPrinngImg6} alt="" />
																	<div className="hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg-new">
																		<h5>
																			Seventh...?
																			
																		</h5>

																		<h3>
																			Estimated <br />
																			2024
																		</h3>
																	</div>
																</div>
															</Col>
														</SwiperSlide>
														<SliderButtons />
													</Swiper>
												</div>
											</TabPane>
										</TabContent>
									</Col>
								)}
							</Row>

							
						</Container>
					</div> */}

          {/* Pricing New  */}

          {/* Pricing old  */}
          {/* <div className=""> */}
          {/* <Row>
                {currentActiveTab === "1" ? (
                  <Col className="text-center">
                    <Button className="btn-primary">
                      Order All Three (${plans["month"]["all"]["price"]}/m)
                    </Button>
                  </Col>
                ) : (
                  <Col className="text-center">
                    <Button className="btn-primary">
                      Order All Three (${plans["year"]["all"]["price"]}/y)
                    </Button>
                  </Col>
                )}
              </Row> */}
          {reviewList && (
            <div className="hp-pricing-new">
              <Container>
                <div className="hp-review new-hp-review">
                  <div
                    className="flexRowStart jc-spb w-100 mb-5"
                    style={window.innerWidth < 600 ? { flexWrap: "wrap" } : {}}
                  >
                    <h2>
                      Real reviews from <span>real</span> <br />
                      <span>people</span> like you!
                    </h2>

                    <button
                      onClick={args.toggleReview}
                      className="btn btn-primary d-block"
                    >
                      Add Review
                    </button>
                  </div>
                  <Swiper loop {...RealReviewsSetting}>
                    {/* <SwiperSlide key={1}>
                    <div className="item hp-review-box">
                      <div className="hp-review-title">Fynley Wilkinson</div>
                      <div className="hp-review-subtitle">
                        Chief Creative Officer
                      </div>
                      <p>
                        Lorem ipsum dolor sit amet consectetur adipiscing elit
                        Etiam at ipsum at ligula vestibulum sodales Sed. Lorem
                        ipsum dolor sit amet consectetur adipiscing elit Etiam
                        at ipsum at ligula vestibulum sodales Sed.{" "}
                      </p>
                    </div>
                  </SwiperSlide> */}
                    {reviewList.map((item) => (
                      <SwiperSlide key={item.id}>
                        <div
                          className="item hp-review-box"
                          style={{ height: maxHeight }}
                        >
                          <div className="hp-review-title">{item.name}</div>
                          {/* <div className="hp-review-subtitle">{item.role}</div> */}
                          <p>{item.body}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                    {reviewList.length > 1 && <SliderButtons />}
                  </Swiper>
                </div>
              </Container>
            </div>
          )}

          {/* </div> */}
          <Modal
            isOpen={seamlessModal}
            toggle={toggleSeamlessModal}
            style={
              window.innerWidth > 600
                ? {
                    // position: 'absolute',
                    top: "50%",
                    transform: "translateY(-50%)",
                  }
                : {
                    top: "0%",
                    transform: "translateY(0%)",
                  }
            }
            className="modal-lg"
          >
            <ModalHeader
              toggle={toggleSeamlessModal}
              style={{ paddingTop: "0px", paddingBottom: "0px" }}
            >
              {window.innerWidth > 600 ? (
                <h2
                  style={{
                    fontSize: "20px",
                    lineHeight: "32px",
                    paddingTop: "30px",
                    fontWeight: "400",
                  }}
                >
                  While each of these services is independently designed,
                  together they weave a tapestry of insights about your inner
                  self
                </h2>
              ) : (
                <h5
                  style={{
                    fontSize: "20px",
                    lineHeight: "32px",
                    paddingTop: "30px",
                    fontWeight: "400",
                  }}
                >
                  While each of these services is independently designed,
                  together they weave a tapestry of insights about your inner
                  self
                </h5>
              )}
            </ModalHeader>
            <ModalBody style={{ paddingTop: "0px" }}>
              <div className="flexColCenter al-center ">
                <img
                  // className="icon-48"
                  style={
                    window.innerWidth > 600
                      ? {
                          flex: 1,
                          paddingTop: "16px",
                          paddingBottom: "16px",
                          maxWidth: "690px",
                          maxHeight: "196px",
                        }
                      : {
                          flex: 1,
                          paddingTop: "16px",
                          paddingBottom: "16px",
                          maxWidth: "358px",
                          maxHeight: "102px",
                        }
                  }
                  src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp_services_icons.png?t=2024-01-10T04%3A54%3A02.823Z"
                  alt=""
                />
              </div>
              <p style={{ textAlign: "center" }}>
                An example of their collaborative power might be, if you were
                anxious about an upcoming project, you then express this in
                SeventhJOURNAL as you spend a few moments reflecting on your
                day. The manifestation of a dream symbol that night, such as
                teeth falling out, analyzed by SeventhSIGHT, might then be
                linked to this underlying stress. As a response, SeventhGUIDE
                tailors your next day's meditation frequencies specifically to
                reduce your anxiety. The refined understanding of your archetype
                from SeventhARC enriches this process by identifying techniques
                best suited to your personality type. This detailed profile is
                then shared with your dedicated counselor in SeventhCARE,
                allowing them to provide personalized guidance, if you choose,
                alleviating any lingering anxiety, and providing pragmatic
                solutions to navigate life's challenges.
              </p>
            </ModalBody>
          </Modal>
        </div>
      </div>
      {/* Pricing old  */}
    </React.StrictMode>
  );
};

export default Home;
const SliderButtons = () => {
  const swiper = useSwiper();
  return (
    <div className="flexCenter w-100 cg-1" style={{ marginTop: "1rem" }}>
      <RoundButtonDark
        type={"backward"}
        filled={false}
        onClick={() => {
          swiper.slidePrev();
        }}
      />
      <RoundButtonDark
        type={"forward"}
        filled={false}
        onClick={() => {
          swiper.slideNext();
        }}
      />
    </div>
  );
};
